import { render, staticRenderFns } from "./AnswerManagement.vue?vue&type=template&id=b8374752"
import script from "./AnswerManagement.vue?vue&type=script&lang=js"
export * from "./AnswerManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports